import { render, staticRenderFns } from "./UpdatePlanCompany.vue?vue&type=template&id=4fe184e0"
import script from "./UpdatePlanCompany.vue?vue&type=script&lang=js"
export * from "./UpdatePlanCompany.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlanCompany.vue?vue&type=style&index=0&id=4fe184e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports